import { Section, SectionType } from '../types';
import { FunctionComponent } from 'react';
import { ColumnSectionElement } from './column';
import { TabbedSectionElement } from './tabbed';
import { UnknownSection } from './unknown';
import { SectionProps } from './types';

const sectionsMap: Record<SectionType, FunctionComponent<SectionProps>> = {
  tabbed: TabbedSectionElement,
  column: ColumnSectionElement,
  unknown: UnknownSection,
};

export function getSectionElement(section: Section): FunctionComponent<SectionProps> {
  return sectionsMap[section.type];
}
